import { Box, Tab, Tabs } from '@mui/material';
import { Link } from 'react-router-dom';
import { useLocale } from 'use-intl';

import useRouteMatch from '../../../hooks/useRouteMatch';

interface SettingsTabsProps {
  label: string;
  path: string;
}

interface LinkTabsProps {
  settingsTabs: SettingsTabsProps[];
  end?: boolean;
}

const LinkTabs = (props: LinkTabsProps) => {
  const { settingsTabs, end = true } = props;
  const routeMatch = useRouteMatch(
    settingsTabs.map(({ path }) => path),
    end
  );
  const currentTab = routeMatch?.pattern?.path;
  const titleCase = useLocale() === 'en';

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={currentTab || false} >
        {settingsTabs.map(({ label, path }) => (
          <Tab
            key={path}
            label={label}
            value={path}
            to={path}
            component={Link}
            sx={{ textTransform: titleCase ? undefined : 'none' }}
          />
        ))}
      </Tabs>
    </Box>
  );
};
export default LinkTabs;
